export default {
    idBranch: {
        label: 'Lojas',
        field: 'idBranch',
        type: 'general',
        align: 'left',
        customWidth: 220,
        fixed: false,
        render: true,
        disableOrder: false
    },
    dtCreate: {
        label: 'Data',
        type: 'general',
        field: 'dtCreate',
        align: 'left',
        customWidth: 140,
        render: true,
        fixed: false,
        disableOrder: false
    },
    dtStartCount: {
        label: 'Início',
        type: 'general',
        field: 'dtStartCount',
        align: 'left',
        customWidth: 140,
        render: true,
        fixed: false,
        disableOrder: false
    },
    dtEndCount: {
        label: 'Fim',
        type: 'general',
        field: 'dtEndCount',
        align: 'left',
        customWidth: 140,
        render: true,
        fixed: false,
        disableOrder: true
    },
    cdLm: {
        label: 'lm_label',
        field: 'cdLm',
        type: 'general',
        align: 'left',
        customWidth: 100,
        fixed: false,
        render: true,
        disableOrder: true
    },
    dsProduct: {
        label: 'reports.description',
        field: 'dsProduct',
        type: 'general',
        align: 'left',
        customWidth: 170,
        fixed: false,
        render: true,
        disableOrder: true,
        fullWidth: true,
    },
    dsSection: {
        label: 'delimit.report.table.section',
        field: 'dsSection',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true
    },
    dsLot: {
        label: 'Lote',
        field: 'dsLot',
        type: 'general',
        align: 'left',
        customWidth: 70,
        fullWidth: true,
        fixed: false,
        render: true,
        disableOrder: true
    },
    warehouseType: {
        label: 'Tipo de depósito',
        field: 'warehouseType',
        type: 'wrapLine',
        align: 'left',
        customWidth: 85,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    idStorageBin: {
        label: 'Posição no depósito',
        field: 'idStorageBin',
        type: 'wrapLine',
        align: 'left',
        customWidth: 95,
        fixed: false,
        render: true,
        disableOrder: true
    },
    warehouseUnit: {
        label: 'UD',
        field: 'warehouseUnit',
        type: 'general',
        align: 'left',
        customWidth: 140,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    counted: {
        label: 'Contado',
        field: 'counted',
        type: 'general',
        align: 'left',
        customWidth: 90,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    firstCount: {
        label: '1.ª contagem',
        field: 'firstCount',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    secondCount: {
        label: '2.ª contagem',
        field: 'secondCount',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    thirdCount: {
        label: '3.ª contagem',
        field: 'thirdCount',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    inIntegrated: {
        label: 'Posição Integrada',
        field: 'inIntegrated',
        type: 'general',
        align: 'left',
        customWidth: 150,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    accuracy: {
        label: 'Acuracidade',
        field: 'accuracy',
        type: 'general',
        align: 'left',
        customWidth: 120,
        fixed: false,
        render: true,
        disableOrder: true,
    },
    currentPositionInventory: {
        label: 'Estoque pré IRC',
        field: 'currentPositionInventory',
        type: 'general',
        align: 'left',
        customWidth: 140,
        fixed: false,
        render: true,
        disableOrder: true
    },
    postPositionInventory: {
        label: 'Estoque pós IRC',
        field: 'postPositionInventory',
        type: 'general',
        align: 'left',
        customWidth: 140,
        fixed: false,
        render: true,
        disableOrder: true
    },
    dpac: {
        label: 'Valor Unit (CMUP)',
        field: 'dpac',
        type: 'wrapLine',
        align: 'left',
        customWidth: 85,
        fixed: false,
        render: true,
        disableOrder: true,
        fullWidth: true,
    },
    diff: {
        label: 'Diferença (valor)',
        field: 'diff',
        type: 'wrapLine',
        align: 'left',
        customWidth: 85,
        fixed: false,
        render: true,
        disableOrder: true,
        fullWidth: true,
    },
    dsProvider: {
        label: 'Fornecedor',
        field: 'dsProvider',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
        fullWidth: true,
    },
    dsJustification: {
        label: 'Justificativa',
        field: 'dsJustification',
        type: 'general',
        align: 'left',
        customWidth: 240,
        fullWidth: true,
        fixed: false,
        render: true,
        disableOrder: true
    },
    dsLdap: {
        label: 'LDAP - Nome',
        field: 'dsLdap',
        type: 'general',
        align: 'left',
        customWidth: 260,
        fixed: false,
        render: true,
        disableOrder: true
    },
};
